module.exports = __webpack_public_path__ + "img/forgetPass.84e68967.png";